const state = {
    dropsData: {
        daily: null,
        weekly: null,
        monthly: null,
        firstDeposit: null,
        secondDeposit: null,
        highroller: null,
        socialMedia: null,
        loading: false
    }
}

const getters = {
    dropsData: state => state.dropsData
}

const mutations = {
    drops_set_data(state, data) {
        state.dropsData.daily = data.daily;
        state.dropsData.weekly = data.weekly;
        state.dropsData.monthly = data.monthly;
        if (data.firstDeposit !== undefined) state.dropsData.firstDeposit = data.firstDeposit;
        if (data.secondDeposit !== undefined) state.dropsData.secondDeposit = data.secondDeposit;
        if (data.highroller !== undefined) state.dropsData.highroller = data.highroller;
        if (data.socialMedia !== undefined) state.dropsData.socialMedia = data.socialMedia;
    },
    drops_set_data_loading(state, status) {
        state.dropsData.loading = status;
    }
}

const actions = {
    dropsGetDataSocket({ getters, commit, dispatch }, data) {
        if(getters.socketGeneral === null || getters.dropsData.loading === true) { return; }
        commit('drops_set_data_loading', true);

        getters.socketGeneral.emit('getDropsData', data, (res) => {
            if(res.success === true) {
                commit('drops_set_data', res.drops);
            } else {
                dispatch('notificationShow', res.error);
            }

            commit('drops_set_data_loading', false);
        });
    },
    dropsSendClaimSocket({ getters, commit, dispatch }, data) {
        if(getters.socketGeneral === null || getters.socketSendLoading !== null) { return; }
        commit('socket_set_send_loading', 'DropsClaim');

        getters.socketGeneral.emit('sendDropsClaim', data, (res) => {
            if(res.success === true) {
                commit('auth_update_user', res.user);
                
                const periodName = data.period.charAt(0).toUpperCase() + data.period.slice(1);
                // Convert claimed amount from system format (divide by 1000 for display)
                const displayAmount = (res.claimed / 1000).toFixed(2);
                dispatch('notificationShow', { 
                    type: 'success', 
                    message: `You have successfully claimed $${displayAmount} from ${periodName} Drops!` 
                });

                // Refresh drops data after claiming
                dispatch('dropsGetDataSocket', {});
            } else {
                dispatch('notificationShow', res.error);
            }

            commit('socket_set_send_loading', null);
        });
    }
}

const drops = {
    state,
    mutations,
    actions,
    getters
}

export default drops;
